import React from "react";
import { EmptyContent } from "core/components/EmptyContent";

export const ServiceUnavailableView = () => (
  <EmptyContent>
    <p>
      We apologize for the inconvenience, but we have had to temporarily disable
      the Reports view.
      <br />
      This does <b>NOT</b> need to be reported to our oncall channel,
      Engineering is aware, and will re-enable it as soon as possible!
      <br />
      Thank you for your understanding!
    </p>
  </EmptyContent>
);
